import * as React from "react";

function SvgTableIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16.4}
      height={20.4}
      {...props}
    >
      <g data-name="clipboard (2)">
        <g data-name="Grupo 2252">
          <g data-name="Grupo 2251">
            <path
              data-name="Caminho 565"
              d="M11.95 8.533h-7.5a.833.833 0 000 1.667h7.5a.833.833 0 100-1.667z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth={0.4}
            />
          </g>
        </g>
        <g data-name="Grupo 2254">
          <g data-name="Grupo 2253">
            <path
              data-name="Caminho 566"
              d="M11.95 12.7h-7.5a.833.833 0 100 1.667h7.5a.833.833 0 100-1.667z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth={0.4}
            />
          </g>
        </g>
        <g data-name="Grupo 2256">
          <g data-name="Grupo 2255">
            <path
              data-name="Caminho 567"
              d="M13.674 2.7h-.885a2.933 2.933 0 00-2.9-2.5H6.517a2.933 2.933 0 00-2.9 2.5h-.89A2.516 2.516 0 00.2 5.2v12.5a2.516 2.516 0 002.527 2.5h10.947a2.516 2.516 0 002.526-2.5V5.2a2.516 2.516 0 00-2.526-2.5zm-7.157-.833h3.368a1.25 1.25 0 110 2.5H6.517a1.25 1.25 0 110-2.5zm8 15.833a.839.839 0 01-.842.833H2.727a.839.839 0 01-.842-.833V5.2a.839.839 0 01.842-.833h1.137a2.946 2.946 0 002.653 1.666h3.368a2.946 2.946 0 002.652-1.667h1.138a.839.839 0 01.842.834v12.5z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth={0.4}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgTableIcon;

